'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { InternalNetworkExecutionSelectDialog } from './InternalNetworkExecutionSelectDialog';
import {
  EXECUTION_TIER_VALUES,
  isInternalNetworkExecutionTier,
  type InternalNetworkExecutionTier,
} from './internal-execution.model';

export type InternalNetworkExecutionTierDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  executionTier: InternalNetworkExecutionTier;
  isDiscoveryActive: boolean;
  isUpdating: boolean;
  onSubmit: (tier: InternalNetworkExecutionTier) => Promise<boolean>;
};

export function InternalNetworkExecutionTierDialog({
  open,
  onOpenChange,
  executionTier,
  isDiscoveryActive,
  isUpdating,
  onSubmit,
}: InternalNetworkExecutionTierDialogProps) {
  const t = useTranslations('designSystem.networkSettings.internalExecution');
  const items = useMemo(
    () =>
      EXECUTION_TIER_VALUES.map((tier) => ({
        label: t(`executionTierValues.${tier}`),
        value: tier,
      })),
    [t],
  );

  return (
    <InternalNetworkExecutionSelectDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('editExecutionTierTitle')}
      label={t('executionTier')}
      value={executionTier}
      items={items}
      isValue={isInternalNetworkExecutionTier}
      isSubmitBlocked={isDiscoveryActive}
      isUpdating={isUpdating}
      onSubmit={onSubmit}
    />
  );
}
